import Vue from 'vue';
import axios from 'axios';
import { requestInventoryJson } from './inventory-json';

// Performance optimization utilities
const StringCache = {
  normalized: new Map(),
  lowercase: new Map(),
  
  normalize(str) {
    if (!str) return '';
    const key = str;
    if (this.normalized.has(key)) return this.normalized.get(key);
    const result = String(str).replace(/[ ,]/g, '-').replace(/-+/g, '-').toLowerCase();
    this.normalized.set(key, result);
    return result;
  },
  
  toLower(str) {
    if (!str) return '';
    if (this.lowercase.has(str)) return this.lowercase.get(str);
    const result = String(str).toLowerCase();
    this.lowercase.set(str, result);
    return result;
  },
  
  clear() {
    this.normalized.clear();
    this.lowercase.clear();
  }
};

// Helper to convert array to Set for O(1) lookups
const toSet = (arr) => new Set(arr);

// Helper to check if value is empty
const isEmpty = (val) => val === undefined || val == null || val.length <= 0;

const EventBus = new Vue({
  data() {
    return {
      inventory: [],
      ufInventory: [],
      options: {},
      requestInventoryCallbacks: [],
      requestInventoryStatus: 'WAITING_REQUEST',
      usedFinancing: [],
      doPayments: false,
      vehicleMatcher: {
        vehicle: null,
      },
      // Support for multiple inventory instances
      instances: {},
      // Counter for inventory instances on the page
      inventoryInstanceCount: 0,
    }
  },
  created() {
    window.addEventListener("load", this.onWindowLoad);
  },
  methods: {
    // Generate unique instance ID
    generateInstanceId() {
      return 'inv_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    },

    // Register a new inventory instance
    registerInstance(instanceId) {
      if (!this.instances[instanceId]) {
        this.instances[instanceId] = {
          inventory: [],
          options: {},
          filteredInventory: []
        };
      }
      return this.instances[instanceId];
    },

    // Get instance data
    getInstance(instanceId) {
      return this.instances[instanceId] || null;
    },

    // Emit event for specific instance only
    emitToInstance(eventName, instanceId, payload) {
      this.$emit(eventName + '_' + instanceId, payload);
    },

    onWindowLoad() {
        var url = window.location.href;
        var childStyleEl = document.getElementById('child-theme-styles-css');
        if (!url.includes('local') && childStyleEl) {
          var buildPath = '/wp-content/themes/base/resources/assets/styles/build/';
          axios.get(buildPath + 'mix-manifest.json?v=' + Date.now())
          .then(response => {
            var current = response.data && response.data['/dealer.css'];
            if (!current)
              return;

            var href = buildPath + current.replace(/^\//, '');
            if (childStyleEl.href.indexOf(href) !== -1)
              return;

            childStyleEl.href = href;
            var preloadEl = document.getElementById('preload-child-css');
            if (preloadEl)
              preloadEl.href = href;
          })
          .catch(() => {
          });
        }
    },
    getUsedFinance() {
      return new Promise((resolve, reject) => {
        wp.ajax.post("get_used_finance", {})
          .done((response) => {
            this.usedFinancing = JSON.parse(response);
            resolve();
          })
          .fail(() => {
            this.usedFinancing = JSON.parse("");
            reject();
          });
      });
    },
    findDoPayments() {
      return new Promise((resolve, reject) => {
        wp.ajax.post("do_payments", {})
          .done((response) => {
            this.doPayments = JSON.parse(response);
            resolve();
          })
          .fail(() => {
            this.doPayments = JSON.parse("");
            reject();
          });
      });
    },
    tryGetFormSubmission() {
      wp.ajax.post("get_leadbox_ninja_forms_after_submission")
        .done((response) => {})
        .fail(() => {})
    },
    tryGetInventoryFrom(target, callback, params) {
      wp.ajax.post("get_leadbox_inventory_from_" + target, { 'params': params })
        .done((response) => {
          this.inventory = JSON.parse(response);
          callback(true);
        })
        .fail(() => {
          callback(false);
        })
    },
    httpRequestInventory(contentdir, callback, gutembergOptions) {
      switch (this.requestInventoryStatus) {
        case "WAITING_REQUEST": {
          this.requestInventoryStatus = "REQUESTING_INVENTORY";
          let setPayments = localStorage.getItem("lbx_setPayments");

          this.getUnfilteredInventory(this)
            .then((unfilteredInventory) => {
              this.inventory = unfilteredInventory;
              this.ufInventory = unfilteredInventory;

              // Retornar la promesa de findDoPayments
              return this.findDoPayments().then((success) => {
                if (this.inventory.length > 0 && !setPayments && this.doPayments) {
                  // Retornar la promesa de getUsedFinance y setPayments
                  return this.getUsedFinance().then(() => this.setPayments());
                } else {
                  return this.inventory; // Retornar inventory como promesa resuelta
                }
              });
            })
            .then((success) => {
              if (success) {
                this.inventory = success;
              }

              this.options = gutembergOptions;
              this.gutembergOptionsFiltering();
              this.requestInventoryStatus = "REQUEST_SUCCESSFULLY_COMPLETED";

              const inventoryData = JSON.parse(JSON.stringify(this.inventory));
              callback(inventoryData);
            })
            .catch((error) => {
              this.requestInventoryStatus = "REQUEST_FAILED";
              callback([]);
            })
            .finally(() => {
              this.sendRemainingCallbacks(this.ufInventory);
            });
          break;
        }
        case "REQUESTING_INVENTORY":
          this.requestInventoryCallbacks.push({ callback, gutembergOptions });
          break;
        case "REQUEST_SUCCESSFULLY_COMPLETED": {
          const inventoryData = JSON.parse(JSON.stringify(this.inventory));
          callback(inventoryData);
          break;
        }
        case "REQUEST_INVENTORY_FAILED":
          callback([]);
          break;
      }
    },

    // Filter inventory based on gutemberg options for a specific instance
    filterInventoryForInstance(inventory, options) {
      if (!options) return inventory;

      // Store current state
      const originalInventory = this.inventory;
      const originalOptions = this.options;

      // Apply filtering
      this.inventory = inventory;
      this.options = options;
      this.filterVehicles();
      this.sortInventory({
        field: options.sort_by,
        order: options.sort_by_condition,
        fieldSecondary: options.sort_by_secondary,
        orderSecondary: options.sort_by_condition_secondary,
      });
      this.limit();

      const filteredInventory = JSON.parse(JSON.stringify(this.inventory));

      // Restore original state
      this.inventory = originalInventory;
      this.options = originalOptions;

      return filteredInventory;
    },    
    getAllInventory(callback) {
      requestInventoryJson().then(callback);
    },
    getUnfilteredInventory(vueThis) {
      return new Promise(function (resolve, reject) {
        sessionStorage.removeItem("unfilteredInventory");
        
        let existsLastUpdate = sessionStorage.getItem("lastUpdateInventoryJSON");
        let needsUpdate = EventBus.needsUpdateJSONTimestamp(5, "Inventory");

        let lang = document.documentElement.lang;
        var lg = "";

        if (lang && lang == "fr-CA") {
          lg = "_fr";
          sessionStorage.setItem("lbxLang", lang);
        } else if (lang && lang == "en-CA") {
          sessionStorage.setItem("lbxLang", lang);
        }

        vueThis
          .checkIndexedDBExists("lbx-inventory", "inventory")
          .then((response) => {
            if (!response || needsUpdate || !existsLastUpdate) {
              console.warn("LBX: Inv has no response or 5 mins has passed or no lastUpdateInventoryJSON");

              axios.get("/wp-content/uploads/data/inventory" +lg +".json?v=" +EventBus.getJSONTimestamp(5, "Inventory"))
                .then((response) => {
                  vueThis
                    .storeInventoryData(response.data.vehicles)
                    .then(() => {
                      resolve(response.data.vehicles);
                    })
                    .catch((error) => {
                      resolve(response.data.vehicles);
                    });
                })
                .catch((error) => {
                  reject();
                });
            } else {
              console.warn("LBX: Inv has response or 5 mins has not passed");

              vueThis
                .getInventoryData()
                .then((response) => {
                  console.warn("LBX: Inv has response or 5 mins has not passed but getInventoryData");
                  resolve(response);
                })
                .catch((error) => {
                  console.warn("LBX: Inv has response or 5 mins has not passed but error on getInventoryData");
                  reject();
                });
            }
          });

        //}
      });
    },
    isUnfilteredInventoryOnSessionStorage(){
        if(sessionStorage.getItem('unfilteredInventory'))
            return true;
        else
            return false;
    },
    isLangOnSessionStorage(){
        if(sessionStorage.getItem('lbxLang'))
            return true;
        else
            return false;
    },
    storeUnfilteredInventoryOnSessionStorage(inventory){
      var inventoryString = JSON.stringify(inventory);
      try {
        sessionStorage.setItem("unfilteredInventory", inventoryString);
      } catch (e) {
        console.log("Error saving to sessionStorage: " + e);
      }
    },
    getUnfilteredInventoryFromSessionStorage(){
        if(this.isUnfilteredInventoryOnSessionStorage()){
            return JSON.parse(sessionStorage.getItem('unfilteredInventory'));
        }else{
            return [];
        }
    },
    getLangFromSessionStorage(){
        if(this.isLangOnSessionStorage()){
            return sessionStorage.getItem('lbxLang');
        }else{
            return false;
        }
    },
    initializeIndexedDB() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("lbx-inventory", 2);

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          db.createObjectStore("inventory", { keyPath: "id" });
        };

        request.onsuccess = (event) => {
          const db = event.target.result;
          resolve(db);
        };

        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    },
    storeInventoryData(data) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("lbx_setPayments");
        
        // Clear string cache when new inventory is loaded (PERFORMANCE OPTIMIZATION)
        StringCache.clear();

        this.initializeIndexedDB()
          .then((db) => {
            const transaction = db.transaction("inventory", "readwrite");
            const store = transaction.objectStore("inventory");

            transaction.oncomplete = () => {
              resolve();
            };

            transaction.onerror = (event) => {
              reject(event.target.error);
            };

            // Limpiar datos antiguos del inventario
            store.clear();

            data.forEach((vehicle) => {
              // Calculate final price (price after cash rebates)
              // cashrebatesamount is negative when there are discounts, or 0 when there are none
              const price = parseFloat(vehicle.price) || 0;
              const cashRebates = parseFloat(vehicle.cashrebatesamount) || 0;
              vehicle.cashprice = price + cashRebates;

              store.add(vehicle);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getInventoryData() {
      return new Promise((resolve, reject) => {
        this.initializeIndexedDB()
          .then((db) => {
            const transaction = db.transaction("inventory", "readonly");
            const store = transaction.objectStore("inventory");
            const request = store.getAll();

            request.onsuccess = (event) => {
              const data = event.target.result;

              // Ensure cashprice is calculated for all vehicles
              data.forEach((vehicle) => {
                if (vehicle.cashprice === undefined) {
                  const price = parseFloat(vehicle.price) || 0;
                  const cashRebates = parseFloat(vehicle.cashrebatesamount) || 0;
                  vehicle.cashprice = price + cashRebates;
                }
              });

              resolve(data);
            };

            request.onerror = (event) => {
              reject(event.target.error);
            };
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkIndexedDBExists(dbName, storeName) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName);

        request.onsuccess = (event) => {
          const db = event.target.result;
          const objectStoreNames = db.objectStoreNames;

          if (objectStoreNames.contains(storeName)) {
            db.close();
            resolve(true);
          } else {
            db.close();
            resolve(false);
          }
        };

        request.onerror = () => {
          resolve(false);
        };

        request.onupgradeneeded = () => {
          resolve(false);
        };

        request.onblocked = () => {
          reject(
            new Error("La base de datos está bloqueada por otra transacción")
          );
        };
      });
    },
    sendRemainingCallbacks(inventory) {
      this.requestInventoryCallbacks.forEach((cb) => {
        // Make a fresh copy of the unfiltered inventory for each callback
        // This ensures each component gets its own filtered version based on its gutembergOptions
        this.inventory = JSON.parse(JSON.stringify(inventory));
        this.options = cb.gutembergOptions;
        this.gutembergOptionsFiltering();
        cb.callback(JSON.parse(JSON.stringify(this.inventory)));
      });
      // Clear the callbacks after processing
      this.requestInventoryCallbacks = [];
    },
    checkValidCDN(url){
      if(url){
        let cdns =  ['cardealerstg.blob.core.windows.net', 'dealerphotocdn.azureedge.net', 'dealerphoto.blob.core.windows.net', 'vehicleimages.leadboxhq.com'];
        for (var i = 0; i < cdns.length; i++) {
          if (url.toLowerCase().indexOf(cdns[i]) !== -1) {
            return true;
          }
        }
        return false;
      }else
        return false;
    },
    gutembergOptionsFiltering() {
      this.filterVehicles();
      this.sortInventory({ 
        field: this.options.sort_by, 
        order: this.options.sort_by_condition, 
        fieldSecondary: this.options.sort_by_secondary,
        orderSecondary: this.options.sort_by_condition_secondary, 
      });
      this.limit();
    },
    limit() {
      if (this.options.limit > 0)
        this.inventory = this.inventory.slice(0, this.options.limit)
    },
    sortInventory(payload) {
      if(payload.field === 'make (custom)') {

        let uniqueMakes = this.inventory.map(item => item.make).filter((value, index, self) => self.indexOf(value) === index);
        let makesOrder = this.options.sort_makes;
        
        makesOrder = this.arrayUnique(makesOrder.concat(uniqueMakes)); 
        makesOrder = makesOrder.map(element => StringCache.toLower(element));

        const numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        const SortingPrioritize = (PrioList = [], secondaryField = null, secondaryOrder = null) => {
          return (itemA, itemB) => {
            let a = itemA.make;
            let b = itemB.make;
            let aPos = PrioList.indexOf(a.toLowerCase()),
              bPos = PrioList.indexOf(b.toLowerCase());

            let makeComparison = aPos > -1 && bPos > -1
              ? aPos - bPos
              : aPos > -1
              ? -1
              : bPos > -1
              ? +1
              : a - b;

            // If makes are equal, apply secondary sort
            if (makeComparison === 0 && secondaryField && secondaryOrder && secondaryField !== 'none' && secondaryOrder !== 'none') {
              let valueA = itemA[secondaryField];
              let valueB = itemB[secondaryField];

              // Convert to number if secondary field is numeric
              if (numericFields.includes(secondaryField)) {
                valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
                valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
                valueA = isNaN(valueA) ? 0 : valueA;
                valueB = isNaN(valueB) ? 0 : valueB;
              }

              // Special handling for price/cashprice: move $0 to the end
              if (secondaryField === 'price' || secondaryField === 'cashprice') {
                if (valueA === 0 && valueB !== 0) return 1;  // A is 0, move to end
                if (valueA !== 0 && valueB === 0) return -1; // B is 0, move to end
                if (valueA === 0 && valueB === 0) return 0;  // Both 0, equal
              }

              if (valueA < valueB) {
                return secondaryOrder == "asc" ? -1 : 1;
              }
              if (valueA > valueB) {
                return secondaryOrder == "asc" ? 1 : -1;
              }
              return 0;
            }

            return makeComparison;
          };
        };

        this.inventory.sort(SortingPrioritize(makesOrder, payload.fieldSecondary, payload.orderSecondary));

      } else if(payload.field === 'location (custom)'){

        let uniqueLocations = this.inventory.map(item => item.location).filter((value, index, self) => self.indexOf(value) === index);
        let locationsOrder = this.options.sort_locations;
        
        locationsOrder = this.arrayUnique(locationsOrder.concat(uniqueLocations)); 
        locationsOrder = locationsOrder.map(element => StringCache.toLower(element));
        if (payload.order == 'desc') {
          locationsOrder = locationsOrder.reverse();
        }

        const numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        const SortingPrioritizeLocation = (PrioList = [], secondaryField = null, secondaryOrder = null) =>
        {
            return (itemA, itemB) => {
            const a = itemA.location;
            const b = itemB.location;
            const aLower = StringCache.toLower(a);
            const bLower = StringCache.toLower(b);
            let aPos = PrioList.indexOf(aLower), bPos = PrioList.indexOf(bLower);
            
            let locationComparison = (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b;

            // If locations are equal, apply secondary sort
            if (locationComparison === 0 && secondaryField && secondaryOrder && secondaryField !== 'none' && secondaryOrder !== 'none') {
              let valueA = itemA[secondaryField];
              let valueB = itemB[secondaryField];

              // Convert to number if secondary field is numeric
              if (numericFields.includes(secondaryField)) {
                valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
                valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
                valueA = isNaN(valueA) ? 0 : valueA;
                valueB = isNaN(valueB) ? 0 : valueB;
              }

              // Special handling for price/cashprice: move $0 to the end
              if (secondaryField === 'price' || secondaryField === 'cashprice') {
                if (valueA === 0 && valueB !== 0) return 1;  // A is 0, move to end
                if (valueA !== 0 && valueB === 0) return -1; // B is 0, move to end
                if (valueA === 0 && valueB === 0) return 0;  // Both 0, equal
              }

              if (valueA < valueB) {
                return secondaryOrder == 'asc' ? -1 : 1;
              }
              if (valueA > valueB) {
                return secondaryOrder == 'asc' ? 1 : -1;
              }
              return 0;
            }

            return locationComparison;
            } 
        }

        this.inventory.sort( SortingPrioritizeLocation(locationsOrder, payload.fieldSecondary, payload.orderSecondary) );        

      } else if(payload.field === 'model (custom)'){

        let uniqueModels = this.inventory.map(item => item.model).filter((value, index, self) => self.indexOf(value) === index);
        let modelsOrder = this.options.sort_models;
        
        modelsOrder = this.arrayUnique(modelsOrder.concat(uniqueModels)); 
        modelsOrder = modelsOrder.map(element => StringCache.toLower(element));
        if (payload.order == 'desc') {
          modelsOrder = modelsOrder.reverse();
        }

        const numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        const SortingPrioritizeModel = (PrioList = [], secondaryField = null, secondaryOrder = null) =>
        {
            return (itemA, itemB) => {
            const a = itemA.model;
            const b = itemB.model;
            const aLower = StringCache.toLower(a);
            const bLower = StringCache.toLower(b);
            let aPos = PrioList.indexOf(aLower), bPos = PrioList.indexOf(bLower);
            
            let modelComparison = (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b;

            // If models are equal, apply secondary sort
            if (modelComparison === 0 && secondaryField && secondaryOrder && secondaryField !== 'none' && secondaryOrder !== 'none') {
              let valueA = itemA[secondaryField];
              let valueB = itemB[secondaryField];

              // Convert to number if secondary field is numeric
              if (numericFields.includes(secondaryField)) {
                valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
                valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
                valueA = isNaN(valueA) ? 0 : valueA;
                valueB = isNaN(valueB) ? 0 : valueB;
              }

              // Special handling for price/cashprice: move $0 to the end
              if (secondaryField === 'price' || secondaryField === 'cashprice') {
                if (valueA === 0 && valueB !== 0) return 1;  // A is 0, move to end
                if (valueA !== 0 && valueB === 0) return -1; // B is 0, move to end
                if (valueA === 0 && valueB === 0) return 0;  // Both 0, equal
              }

              if (valueA < valueB) {
                return secondaryOrder == 'asc' ? -1 : 1;
              }
              if (valueA > valueB) {
                return secondaryOrder == 'asc' ? 1 : -1;
              }
              return 0;
            }

            return modelComparison;
            } 
        }

        this.inventory.sort( SortingPrioritizeModel(modelsOrder, payload.fieldSecondary, payload.orderSecondary) );        

      } else if(payload.field === 'trim (custom)'){

        let uniqueTrims = this.inventory.map(item => item.trim).filter((value, index, self) => self.indexOf(value) === index);
        let trimsOrder = this.options.sort_trims;
        
        trimsOrder = this.arrayUnique(trimsOrder.concat(uniqueTrims)); 
        trimsOrder = trimsOrder.map(element => StringCache.toLower(element));
        if (payload.order == 'desc') {
          trimsOrder = trimsOrder.reverse();
        }

        const numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        const SortingPrioritizeTrim = (PrioList = [], secondaryField = null, secondaryOrder = null) =>
        {
            return (itemA, itemB) => {
            const a = itemA.trim;
            const b = itemB.trim;
            const aLower = StringCache.toLower(a);
            const bLower = StringCache.toLower(b);
            let aPos = PrioList.indexOf(aLower), bPos = PrioList.indexOf(bLower);
            
            let trimComparison = (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b;

            // If trims are equal, apply secondary sort
            if (trimComparison === 0 && secondaryField && secondaryOrder && secondaryField !== 'none' && secondaryOrder !== 'none') {
              let valueA = itemA[secondaryField];
              let valueB = itemB[secondaryField];

              // Convert to number if secondary field is numeric
              if (numericFields.includes(secondaryField)) {
                valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
                valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
                valueA = isNaN(valueA) ? 0 : valueA;
                valueB = isNaN(valueB) ? 0 : valueB;
              }

              // Special handling for price/cashprice: move $0 to the end
              if (secondaryField === 'price' || secondaryField === 'cashprice') {
                if (valueA === 0 && valueB !== 0) return 1;  // A is 0, move to end
                if (valueA !== 0 && valueB === 0) return -1; // B is 0, move to end
                if (valueA === 0 && valueB === 0) return 0;  // Both 0, equal
              }

              if (valueA < valueB) {
                return secondaryOrder == 'asc' ? -1 : 1;
              }
              if (valueA > valueB) {
                return secondaryOrder == 'asc' ? 1 : -1;
              }
              return 0;
            }

            return trimComparison;
            } 
        }

        this.inventory.sort( SortingPrioritizeTrim(trimsOrder, payload.fieldSecondary, payload.orderSecondary) );        

      } else if(payload.field === 'stocknumber (custom)' || payload.field === 'stocknumber_custom'){
        // LBT-1453: promote the dealer-defined stocks to the top (in list order);
        // the rest of the inventory follows, sorted by the page's secondary sort
        // (payload.fieldSecondary/orderSecondary) — fallback: natural stocknumber asc.
        var orderArr = this.options.sort_stocks;
        if (!Array.isArray(orderArr) || orderArr.length === 0) {
          var stockCsv = this.options.stock;
          if (typeof stockCsv === 'string' && stockCsv && stockCsv !== 'all') {
            orderArr = stockCsv.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
          } else {
            orderArr = [];
          }
        }
        var positions = {};
        orderArr.forEach(function(s, i){ positions[s] = i; });
        var dir = (payload.order === 'desc') ? -1 : 1;

        var inList = [];
        var outList = [];
        this.inventory.forEach(function(v){
          if (v && v.stocknumber != null && (v.stocknumber in positions)) {
            inList.push(v);
          } else {
            outList.push(v);
          }
        });
        inList.sort(function(a, b) {
          var pa = positions[a.stocknumber];
          var pb = positions[b.stocknumber];
          if (pa === pb) return 0;
          return pa < pb ? -dir : dir;
        });

        var hasSecondary = payload.fieldSecondary && payload.orderSecondary
          && payload.fieldSecondary !== 'none' && payload.orderSecondary !== 'none';
        var restField = hasSecondary ? payload.fieldSecondary : 'stocknumber';
        var restOrder = hasSecondary ? payload.orderSecondary : 'asc';
        var restNumericFields = ['year', 'price', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];
        var restIsNumeric = restNumericFields.indexOf(restField) !== -1;
        var restIsNaturalString = (restField === 'stocknumber' || restField === 'vin');
        outList.sort(function(a, b){
          var av = a[restField];
          var bv = b[restField];
          if (restIsNumeric) {
            av = (av === null || av === undefined || av === '') ? 0 : parseFloat(av);
            bv = (bv === null || bv === undefined || bv === '') ? 0 : parseFloat(bv);
            if (isNaN(av)) av = 0;
            if (isNaN(bv)) bv = 0;
            if (restField === 'price') {
              if (av === 0 && bv !== 0) return 1;
              if (av !== 0 && bv === 0) return -1;
            }
            if (av === bv) return 0;
            return restOrder === 'asc' ? (av < bv ? -1 : 1) : (av < bv ? 1 : -1);
          }
          if (restIsNaturalString) {
            var as = av == null ? '' : String(av);
            var bs = bv == null ? '' : String(bv);
            if (as === '' && bs !== '') return 1;
            if (as !== '' && bs === '') return -1;
            var cmp = as.localeCompare(bs, undefined, { numeric: true, sensitivity: 'base' });
            if (cmp === 0) return 0;
            return restOrder === 'asc' ? cmp : -cmp;
          }
          if (av < bv) return restOrder === 'asc' ? -1 : 1;
          if (av > bv) return restOrder === 'asc' ? 1 : -1;
          return 0;
        });

        this.inventory = inList.concat(outList);

      } else if(payload.field === 'stocknumbers'){

        this.inventory.sort((a, b) => {
          const validOrders = ['asc', 'desc'];
          let order = (payload && payload.order || 'asc').toLowerCase();
      
          if (!validOrders.includes(order)) {
              order = 'asc';
          }
      
          const getStockNumber = (item) => {
              const stockNumber = item && item.stocknumber;
              return stockNumber === undefined || stockNumber === null ? '' : String(stockNumber);
          };
      
          const stockNumberA = getStockNumber(a);
          const stockNumberB = getStockNumber(b);
      
          const compareStockNumbers = () => {
              const numA = Number(stockNumberA);
              const numB = Number(stockNumberB);
      
              if (!isNaN(numA) && !isNaN(numB)) {
                  return (numA - numB) * (order === 'asc' ? 1 : -1);
              } else {
                  return stockNumberA.localeCompare(stockNumberB) * (order === 'asc' ? 1 : -1);
              }
          };
      
          return compareStockNumbers();
        });


        } else if (payload.field === 'totaldiscounts') {
          const groupRank = (v) => {
            const inc = v?.incoming;
            const dem = v?.demo;

            if (inc === false) return 0; // 1ro: incoming false
            if (dem === true)  return 1; // 2do: demo true
            if (inc === true)  return 2; // 3ro: incoming true
            return 3;                    // fallback
          };

          // Mismo total que muestra la card, en negativo para conservar el orden de abajo.
          const effectiveDiscount = (v) => {
            const num = (n) => (Number.isFinite(n) ? n : 0);
            let total = num(Number(v?.totaldiscounts)) + num(Number(v?.cashrebatesamount));

            if (v?.special) {
              const sale = Number(v.saleprice);
              const special = Number(v.specialprice);
              if (Number.isFinite(sale) && Number.isFinite(special) && sale > special) {
                total -= sale - special;
              }
            }

            return total;
          };

          this.inventory.sort((a, b) => {
            const na = effectiveDiscount(a);
            const nb = effectiveDiscount(b);

            const aVal = Number.isFinite(na) ? na : 0;
            const bVal = Number.isFinite(nb) ? nb : 0;

            const aIsZero = aVal === 0;
            const bIsZero = bVal === 0;

            // --- Comparación principal por descuento total ---
            let cmp;

            if (payload.order === 'desc') {
              // Negativos primero; ceros al final
              if (aIsZero && !bIsZero) return 1;
              if (bIsZero && !aIsZero) return -1;

              // Entre negativos (o ambos no-cero): más negativo primero
              cmp = aVal - bVal; // p.ej., -9000 antes que -3000
              if (cmp !== 0) return cmp;

              // --- Tiebreaker/orden secundario SOLO en desc ---
              const ra = groupRank(a);
              const rb = groupRank(b);
              if (ra !== rb) return ra - rb;

              return 0;
            } else {
              // ASC: negativos primero (menos negativo antes), ceros al final
              if (aIsZero && !bIsZero) return 1;
              if (bIsZero && !aIsZero) return -1;

              // Entre negativos: menos negativo primero (más cerca de 0)
              cmp = bVal - aVal; // p.ej., -1500 antes que -3000
              return cmp;
            }
          });
        } else {
        this.inventory.sort((a, b) => {
          // Primary sort
          var nameA = a[payload.field];
          var nameB = b[payload.field];

          // Convert to number if field is numeric
          var numericFields = ['year', 'price', 'cashprice', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];
          if (numericFields.includes(payload.field)) {
            // Handle null, undefined, empty strings more explicitly
            nameA = (nameA === null || nameA === undefined || nameA === '') ? 0 : parseFloat(nameA);
            nameB = (nameB === null || nameB === undefined || nameB === '') ? 0 : parseFloat(nameB);
            // Handle NaN
            nameA = isNaN(nameA) ? 0 : nameA;
            nameB = isNaN(nameB) ? 0 : nameB;
          }

          // Special handling for price/cashprice asc: move $0 to the end (primary sort)
          if ((payload.field === 'price' || payload.field === 'cashprice') && payload.order === 'asc') {
            if (nameA === 0 && nameB !== 0) return 1;  // A is 0, move to end
            if (nameA !== 0 && nameB === 0) return -1; // B is 0, move to end
            // Both 0 or both non-zero, continue with normal comparison
          }

          if (nameA < nameB) {
            return payload.order == "asc" ? -1 : 1;
          }
          if (nameA > nameB) {
            return payload.order == "asc" ? 1 : -1;
          }

          // Values are equal, apply secondary sort if provided
          if (payload.fieldSecondary && payload.orderSecondary && payload.fieldSecondary !== 'none' && payload.orderSecondary !== 'none') {
            var nameASecondary = a[payload.fieldSecondary];
            var nameBSecondary = b[payload.fieldSecondary];

            // Convert to number if secondary field is numeric
            if (numericFields.includes(payload.fieldSecondary)) {
              nameASecondary = (nameASecondary === null || nameASecondary === undefined || nameASecondary === '') ? 0 : parseFloat(nameASecondary);
              nameBSecondary = (nameBSecondary === null || nameBSecondary === undefined || nameBSecondary === '') ? 0 : parseFloat(nameBSecondary);
              nameASecondary = isNaN(nameASecondary) ? 0 : nameASecondary;
              nameBSecondary = isNaN(nameBSecondary) ? 0 : nameBSecondary;
            }

            // Special handling for price/cashprice: move $0 to the end (secondary sort)
            if (payload.fieldSecondary === 'price' || payload.fieldSecondary === 'cashprice') {
              if (nameASecondary === 0 && nameBSecondary !== 0) return 1;  // A is 0, move to end
              if (nameASecondary !== 0 && nameBSecondary === 0) return -1; // B is 0, move to end
              if (nameASecondary === 0 && nameBSecondary === 0) return 0;  // Both 0, equal
            }

            if (nameASecondary < nameBSecondary) {
              return payload.orderSecondary == "asc" ? -1 : 1;
            }
            if (nameASecondary > nameBSecondary) {
              return payload.orderSecondary == "asc" ? 1 : -1;
            }
          }

          return 0;
        });
      }
    },
    arrayUnique(array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i] === a[j])
                  a.splice(j--, 1);
          }
      }
  
      return a;
    },
    filterVehicles() {
      var $_vehicles = [];
      var $_stockWildcard = [];
      var $yearrange = this.parse_range(this.options['year'], true);
      var $pricerange = this.parse_range(this.options['price'], true);
      var $carprooflinkrange = this.parse_range(this.options['carprooflink'], true);
      var $mileagerange = this.parse_range(this.options['mileage'], true);
      var $statusrange = this.normalize_range(this.parse_range(this.options['status']));
      var $makerange = this.normalize_range(this.parse_range(this.options['make']));
      var $modelrange = this.normalize_range(this.parse_range(this.options['model']));
      var $trimrange = this.normalize_range(this.parse_range(this.options['trim']));
      var $locationrange = this.normalize_range(this.parse_range(this.options['location']));
      var $typerange = this.normalize_range(this.parse_range(this.options['type']));
      var $stockrange = this.normalize_range(this.parse_range(this.options['stock']));
      var $tagsrange = this.normalize_range(this.parse_range(this.options['tags']));
      var $flags = this.parse_range(this.options['flags']);
      var $exclude_tags = this.normalize_range(this.parse_range(this.options['exclude_tags']));
      var $fueltyperange = this.optional_range(this.options['fueltype']);
      var $drivetrainrange = this.optional_range(this.options['drivetrain']);
      var $transmissionrange = this.optional_range(this.options['transmission']);

      $stockrange.forEach(element => {
        if (element.includes("*")) {
          $_stockWildcard.push(element.replace("*", ""));
        }
      });

      Object.values(this.inventory).forEach(vehicle => {
        this.vehicleMatcher.vehicle = vehicle;
        var $is_match = this.vehicleMatcherMatch('year', $yearrange) &&
          this.vehicleMatcherMatch('make', $makerange) &&
          this.vehicleMatcherMatch('model', $modelrange) &&
          this.vehicleMatcherMatch('trim', $trimrange) &&
          this.vehicleMatcherMatch('location', $locationrange) &&
          this.vehicleMatcherMatch('price', $pricerange) &&
          this.vehicleMatcherMatch('mileage', $mileagerange) &&
          this.vehicleMatcherMatch('type', $typerange) &&
          this.vehicleMatcherMatchOptional('fueltype', $fueltyperange) &&
          this.vehicleMatcherMatchOptional('drivetrain', $drivetrainrange) &&
          this.vehicleMatcherMatchOptional('transmission', $transmissionrange) &&
          this.vehicleMatcherMatch('condition', $statusrange, 'status') &&
          this.vehicleMatcherMatch('stocknumber', $stockrange, 'stock', $_stockWildcard) &&
          this.vehicleMatcherMatchAny('tags', $tagsrange) &&
          this.vehicleMatcherNoTags($exclude_tags) &&
          this.vehicleMatcherMatchFlags($flags);

        if ($is_match) {
          $_vehicles.push(vehicle);
        }
      })

      this.inventory = $_vehicles;
    },
    parse_range($value, $evaluateHyphen = false) {
      var $range = [];
      if ($value && $value != 'all') {
        if ($evaluateHyphen && $value.indexOf('-') !== -1) {
          $range = $value.split('-');
          $range = this.range($range[1] - $range[0], $range[0]);
        } else if ($value.indexOf(',') !== -1) {
          $range = $value.split(',');
        } else {
          $range = [$value];
        }
      }

      return $range;
    },
    normalize_range($range) {
      return $range.map($item => String($item).trim().toLowerCase()).filter($item => $item !== '');
    },
    optional_range($value) {
      if (typeof $value !== 'string') return [];
      return this.parse_range($value)
        .map($item => String($item).trim().toLowerCase())
        .filter($item => $item !== '');
    },
    vehicleMatcherMatchOptional($property, $values) {
      if (!$values.length) return true;
      var $vehicle = this.vehicleMatcher.vehicle || {};
      var $value = $vehicle[$property] == null ? '' : $vehicle[$property];
      return $values.includes(String($value).trim().toLowerCase());
    },
    range(size, startAt = 0) {
      var range = [];
      for (var i = 0; i <= size; i++) {
        range.push(startAt.toString() || startAt);
        startAt++;
      }
      return range;
    },
    vehicleMatcherMatch($property, $values, $propertyOptions = null, $stockWildcard = null) {
      $propertyOptions = $propertyOptions || $property;
      var $value = (this.vehicleMatcher.vehicle && this.vehicleMatcher.vehicle[$property]) ? this.vehicleMatcher.vehicle[$property] : "";
      var $normalizedValue = String($value).trim().toLowerCase();
      var $findWildcard = false;
      if ($propertyOptions == "stock") {
        if ($stockWildcard) {
          if ($stockWildcard.length > 0) {
              $stockWildcard.forEach(element => {
              if ($normalizedValue.includes(element)) {
                $findWildcard = true;
              }
            });
          }
        }
      }
      if ($findWildcard == true) {
        return true;
      } else {
        return this.options[$propertyOptions] == 'all' || $values.includes($normalizedValue || parseFloat($value));
      }
    },
    vehicleMatcherMatchAny($property, $values, $delimiter = ',', $propertyOptions = null) {

      $propertyOptions = $propertyOptions || $property;

      if (this.options[$propertyOptions] == 'all') {
        return true;
      }
      var $arrayValue = (this.vehicleMatcher.vehicle[$property] || '').split($delimiter);

      for (var i = 0; i < $arrayValue.length; i++) {
        if ($values.includes($arrayValue[i].trim().toLowerCase()))
          return true;
      }
      return false;
    },
    vehicleMatcherNoTags($tags) {
      if (($tags.length === 0) || ($tags.length === 1 && $tags[0] == "")) {
        return true;
      }
    
      if (this.vehicleMatcher.vehicle.tags === undefined || this.vehicleMatcher.vehicle.tags === null) {
        return true; 
      }
    
      var $vehicleTags = String(this.vehicleMatcher.vehicle.tags).toLowerCase();

      for (var i = 0; i < $tags.length; i++) {
        if ($vehicleTags.indexOf($tags[i]) !== -1) {
          return false; 
        }
      }
    
      return true;
    },
    vehicleMatcherMatchFlags($flags) {
      if ($flags.length === 0) {
        return true;
      }

      if ($flags.length === 1 && $flags[0] == "none") {
        return true;
      }

      var ret = true;

      for (var i = 0; i < $flags.length; i++) {
        if (!this.vehicleMatcher.vehicle[$flags[i]] && $flags[i] != 'excludeincoming' && $flags[i] != 'excludesalepending' && $flags[i] != 'excludedemo' && $flags[i] != 'excludecertified' && $flags[i] != 'noprice') {
          ret = false;
        }else if ($flags[i] == 'excludeincoming' && this.vehicleMatcher.vehicle['incoming']) {
          ret = false;
        }else if ($flags[i] == 'excludesalepending' && this.vehicleMatcher.vehicle['salepending']) {
          ret = false;
        }else if ($flags[i] == 'excludedemo' && this.vehicleMatcher.vehicle['demo']) {
          ret = false;
        }else if ($flags[i] == 'excludecertified' && this.vehicleMatcher.vehicle['certified']) {
          ret = false;
        }else if ($flags[i] == 'noprice' && this.vehicleMatcher.vehicle['price'] > 0) {
          ret = false;
        }
      }

      return ret;
    },
    string_contains_value(text, filter) {
      const filterLower = filter.toLowerCase();
      const array = filterLower.split("_");
      const total_words = array.length;
      const vehicleLower = text.toLowerCase();
      const vehicle = vehicleLower.split(' ');
      
      let total_coincidences = 0;
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const itemNoDash = item.replace(/-/g, '');
        
        for (let j = 0; j < vehicle.length; j++) {
          const span = vehicle[j];
          if (span.includes(item) || span.replace(/-/g, '').includes(itemNoDash)) {
            total_coincidences++;
            break;
          }
        }
      }

      return total_words === total_coincidences;
    },
    // Geolocate the buyer ONCE and broadcast both their raw position
    // ('lbx:buyer-position', cached on window.LBX_BUYER_POS — used by per-store
    // badges to compute their own distance) and their straight-line distance (km)
    // to the owning site ('lbx:buyer-distance', cached on
    // window.LBX_BUYER_DISTANCE_KM). Shared by the SRP vehicle card and the VDP
    // title, so listeners that mount later can still pick the values up.
    initBuyerDistance() {
      if (typeof window === 'undefined') return;
      if (window.__lbxBuyerDistanceInit) return; // only prompt once per page
      var dealer = window.LBX_DEALER_LOCATION;
      if (!dealer) return;
      // Only prompt for geolocation when there is at least one target with
      // coordinates: the owning site itself, or a per-store entry from the
      // GENIUS['locations'] map (multi-location inventories).
      var hasMainCoords = dealer.lat != null && dealer.lng != null;
      var hasStoreCoords = false;
      if (dealer.locations) {
        for (var store in dealer.locations) {
          var entry = dealer.locations[store];
          if (entry && entry.lat != null && entry.lng != null) { hasStoreCoords = true; break; }
        }
      }
      if (!hasMainCoords && !hasStoreCoords) return;
      if (!navigator || !navigator.geolocation) return;
      window.__lbxBuyerDistanceInit = true;
      var self = this;
      navigator.geolocation.getCurrentPosition(function (pos) {
        var buyerPos = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        window.LBX_BUYER_POS = buyerPos;
        self.$emit('lbx:buyer-position', buyerPos);
        if (hasMainCoords) {
          var km = Math.round(self.haversineKm(buyerPos.lat, buyerPos.lng, dealer.lat, dealer.lng));
          window.LBX_BUYER_DISTANCE_KM = km;
          self.$emit('lbx:buyer-distance', km);
        }
      }, function () { /* denied/unavailable: listeners fall back to city only */ }, { maximumAge: 600000, timeout: 8000 });
    },
    haversineKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // earth radius in km
      var toRad = function (d) { return d * Math.PI / 180; };
      var dLat = toRad(lat2 - lat1);
      var dLon = toRad(lon2 - lon1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    },
    postFilterInventory(initialInventory, payload) {
      var stockNumber = payload.stockNumber;
      var vin = payload.vin || "";
      // Normalize VIN list once (lowercase, strip spaces/dashes). Supports comma-separated
      // values like ?filter_vin=VIN1,VIN2 — match passes if item.vin contains ANY needle.
      var vinList = vin
        ? vin.split(',').map(v => v.trim().toLowerCase().replace(/[\s-]/g, '')).filter(Boolean)
        : [];
      var mileageRange = payload.mileageRange;
      var priceRange = payload.priceRange;
      var carprooflinkRange = payload.carprooflinkRange;
      var paymentRange = payload.paymentRange;
      var paymentFrequency = payload.paymentFrequency.toLowerCase();
      var filterValue = payload.filterValue;
      var selected = payload.selected;
      var dryweightRange = payload.dryweightRange;
      var grossweightRange = payload.grossweightRange;
      var sleepcapacityRange = payload.sleepcapacityRange;

      // Pre-compute normalized Sets for O(1) lookups (PERFORMANCE OPTIMIZATION)
      const normalizedSelectedStatus = new Set(selected.status.map(s => StringCache.normalize(s)));
      const normalizedConditions = new Set(selected.condition.map(c => StringCache.normalize(c)));
      const yearSet = new Set(selected.year);
      const makeSet = new Set(selected.make.map(m => StringCache.normalize(m)));
      const lotSet = new Set(selected.lot.map(l => StringCache.normalize(l)));
      const stockSet = new Set(selected.stock.map(s => StringCache.normalize(s)));
      const typeSet = new Set(selected.type ? selected.type.map(t => StringCache.normalize(t)) : []);
      const subtypeSet = new Set(selected.subtype.join(',').split(',').filter(Boolean).map(s => StringCache.normalize(s)));
      const productlineSet = new Set(selected.productline.map(p => StringCache.toLower(p)));
      const outsidelengthSet = new Set(selected.outsidelength.map(o => StringCache.toLower(o)));
      const modelSet = new Set(selected.model.map(m => StringCache.normalize(m)));
      const trimSet = new Set(selected.trim.map(t => StringCache.normalize(t)));
      const colourSet = new Set(selected.colour.map(c => StringCache.normalize(c)));
      const transmissionSet = new Set(selected.transmission);
      const drivetrainSet = new Set(selected.drivetrain ? selected.drivetrain.map(d => StringCache.normalize(d)) : []);
      const boxsizeSet = new Set(selected.boxsize && selected.boxsize.length > 0 ? selected.boxsize.map(b => StringCache.normalize(b)) : []);
      const enginedisplacementSet = new Set(selected.enginedisplacement.map(e => e.toString()));
      const bodystyleSet = new Set(selected.bodystyle.map(b => StringCache.normalize(b)));
      const fueltypeSet = new Set(selected.fueltype ? selected.fueltype.map(f => StringCache.normalize(f)) : []);
      const stockNumberSet = stockNumber.length > 0 ? new Set(stockNumber.split(',').map(s => StringCache.toLower(s))) : null;
      const locationSet = new Set(selected.location.map(l => l.toUpperCase()));
      const seatSet = new Set(selected.seat.map(s => s.toString()));
      const engineSet = new Set(selected.engine.map(e => StringCache.normalize(e)));
      const floorplanSet = new Set(selected.floorplan);
      const featureSet = new Set(selected.feature.map(f => StringCache.normalize(f)));
      const packageSet = new Set(selected.package.map(p => StringCache.toLower(p)));
      const tagSet = new Set(selected.tag ? selected.tag.map(t => StringCache.toLower(t)) : []);

      const booleanKeys = ['salepending', 'demo', 'asis', 'certified', 'special'];
      const allowedKeys = [
        'condition', 'stocknumber', 'year', 'make', 'lot', 'model', 
        'type', 'subtype', 'trim', 'bodystyle', 
        ...booleanKeys,
        'price', 'carprooflink', 'payments', 'mileage', 
        'exteriorcolor', 'dryweight', 'grossweight', 'sleepcapacity', 
        'length', 'productline', 'vin', 'fueltype', 'drivetrain', 'seat'
      ];
      
      var filteredInventory = [];
      Object.values(initialInventory).forEach(item => {

        var super_string = allowedKeys
          .map(key => {
            const value = item[key];

            if (booleanKeys.includes(key)) {
              return value === true ? key : '';
            }

            return isEmpty(value) ? '' : (key === 'model' ? value + 's' : value);
          })
          .filter(value => value !== '')
          .join(' ');

        // condition
        if (
          item.condition &&
          normalizedConditions.size > 0 &&
          !normalizedConditions.has(StringCache.normalize(item.condition))
        )
          return;
        if (!item.condition && normalizedConditions.size > 0)
          return;

          
          // year
          if (
          item.year &&
          yearSet.size > 0 &&
          !yearSet.has(item.year)
        )
          return;
        if (!item.year && yearSet.size > 0)
        return;
        
        // make
        if (
          item.make &&
          makeSet.size > 0 &&
          !makeSet.has(StringCache.normalize(item.make))
        )
        return;
        if (!item.make && makeSet.size > 0)
        return;
        
        // Lot
        if (
            item.lot &&
            lotSet.size > 0 &&
            !lotSet.has(StringCache.normalize(item.lot))
            )
            return;
            if (!item.lot && lotSet.size > 0)
            return;
            
            // stock
        if (
          item.stocknumber &&
          stockSet.size > 0 &&
          !stockSet.has(StringCache.normalize(item.stocknumber))
        )
          return;
          if (!item.stocknumber && stockSet.size > 0)
          return;
          
          // type
          if (
              item.type &&
              typeSet.size > 0 &&
              !typeSet.has(StringCache.normalize(item.type))
              )
              return;
              if (!item.type && typeSet.size > 0)
                return;
             
              // subtype
        if (
          item.subtype &&
          subtypeSet.size > 0 &&
          !subtypeSet.has(StringCache.normalize(item.subtype))
        )
        return;
        if (!item.subtype && subtypeSet.size > 0)
        return;
        
        // productline
        if (
          item.productline &&
          productlineSet.size > 0 &&
          !productlineSet.has(StringCache.toLower(item.productline))
          )
          return;
          if (!item.productline && productlineSet.size > 0)
          return;
          
          // length
          if (
              item["length"] &&
              outsidelengthSet.size > 0 && item.length &&
              !outsidelengthSet.has(StringCache.toLower(item["length"]))
              )
              return;
              if (!item["length"] && outsidelengthSet.size > 0)
              return;
              
              // floorplantags
        if (
          item.floorplantags &&
          floorplanSet.size > 0
        ) {
          var intersection = selected.floorplan.filter(o => item.floorplantags.includes(o));
          if (intersection.length < selected.floorplan.length)
          return;
        }
        if (!item.floorplantags && floorplanSet.size > 0)
        return;
        
        // model
        if (
          item.model &&
          modelSet.size > 0 &&
          !modelSet.has(StringCache.normalize(item.model))
        ) {
                return;
            }
            if (!item.model && modelSet.size > 0)
            return;
            
            // trim
        if (
          item.trim &&
          trimSet.size > 0 &&
          !trimSet.has(StringCache.normalize(item.trim))
        )
          return;
          if (!item.trim && trimSet.size > 0)
          return;
          
          // exteriorcolor
        if (
          item.exteriorcolor &&
          colourSet.size > 0 &&
          !colourSet.has(StringCache.normalize(item.exteriorcolor))
        )
          return;
        if (!item.exteriorcolor && colourSet.size > 0)
          return;
          
          // transmission
        if (
          item.transmission &&
          transmissionSet.size > 0 &&
          !transmissionSet.has(item.transmission)
        )
          return;
          if (!item.transmission && transmissionSet.size > 0)
          return;
          
          // drivetrain
          if (
              item.drivetrain &&
              drivetrainSet.size > 0 &&
              !drivetrainSet.has(StringCache.normalize(item.drivetrain))
              )
              return;
              if (!item.drivetrain && drivetrainSet.size > 0)
              return;

        // boxsize
        if (
          item.boxsize &&
          boxsizeSet.size > 0 &&
          !boxsizeSet.has(StringCache.normalize(item.boxsize))
          )
          return;
          if (!item.boxsize && boxsizeSet.size > 0)
          return;

          // STATUS FILTER ------------------------------       
          if (
            item.incoming &&
            normalizedSelectedStatus.size > 0 &&
            !normalizedSelectedStatus.has("incoming")
          ) {
            if (!(item.special && normalizedSelectedStatus.has("special"))) {
              if (!(item.demo && normalizedSelectedStatus.has("demo"))) {
                if (!(item.salepending && normalizedSelectedStatus.has("sale-pending"))) {
                  if (!(item.certified && normalizedSelectedStatus.has("certified"))) {
                    if (!(item.asis && normalizedSelectedStatus.has("as-is"))) {
                    return;
                    }
                  }
                }
              }
            }
          }

          if (
            !item.incoming &&
            normalizedSelectedStatus.size > 0 &&
            !normalizedSelectedStatus.has("in-stock")
          ) {
            if (!(item.special && normalizedSelectedStatus.has("special"))) {
              if (!(item.demo && normalizedSelectedStatus.has("demo"))) {
                if (!(item.salepending && normalizedSelectedStatus.has("sale-pending"))) {
                  if (!(item.certified && normalizedSelectedStatus.has("certified"))) {
                    if (!(item.asis && normalizedSelectedStatus.has("as-is"))) {
                      return;
                      }
                  }
                }
              }
            }
          }

          if (
            item.special &&
            normalizedSelectedStatus.size > 0 &&
            !normalizedSelectedStatus.has("special")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.has("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.has("in-stock"))) {
                if (!(item.demo && normalizedSelectedStatus.has("demo"))) {
                  if (!(item.salepending && normalizedSelectedStatus.has("sale-pending"))) {
                    if (!(item.certified && normalizedSelectedStatus.has("certified"))) {
                      if (!(item.asis && normalizedSelectedStatus.has("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.demo &&
            normalizedSelectedStatus.size > 0 &&
            !normalizedSelectedStatus.has("demo")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.has("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.has("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.has("special"))) {
                  if (!(item.salepending && normalizedSelectedStatus.has("sale-pending"))) {
                    if (!(item.certified && normalizedSelectedStatus.has("certified"))) {
                      if (!(item.asis && normalizedSelectedStatus.has("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.salepending &&
            normalizedSelectedStatus.size > 0 &&
            !normalizedSelectedStatus.has("sale-pending")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.has("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.has("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.has("special"))) {
                  if (!(item.demo && normalizedSelectedStatus.has("demo"))) {
                    if (!(item.certified && normalizedSelectedStatus.has("certified"))) {
                      if (!(item.asis && normalizedSelectedStatus.has("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.certified &&
            normalizedSelectedStatus.size > 0 &&
            !normalizedSelectedStatus.has("certified")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.has("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.has("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.has("special"))) {
                  if (!(item.demo && normalizedSelectedStatus.has("demo"))) {
                    if (!(item.salepending && normalizedSelectedStatus.has("sale-pending"))) {
                      if (!(item.asis && normalizedSelectedStatus.has("as-is"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          if (
            item.asis &&
            normalizedSelectedStatus.size > 0 &&
            !normalizedSelectedStatus.has("as-is")
          ) {
            if (!(item.incoming && normalizedSelectedStatus.has("incoming"))) {
              if (!(!item.incoming && normalizedSelectedStatus.has("in-stock"))) {
                if (!(item.special && normalizedSelectedStatus.has("special"))) {
                  if (!(item.demo && normalizedSelectedStatus.has("demo"))) {
                    if (!(item.salepending && normalizedSelectedStatus.has("sale-pending"))) {
                      if (!(item.certified && normalizedSelectedStatus.has("certified"))) {
                        return;
                        }
                    }
                  }
                }
              }
            }
          }

          /* END STATUS FILTER */

        //Salepending
        if (
          item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("1") == false
        )
          return;

          if (
          !item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("0") == false
        )
        return;

        //Demo
        if (
          item.demo &&
          selected.demo.length > 0 &&
          selected.demo.includes("1") == false
        )
          return;

        if (
          !item.demo &&
          selected.demo.length > 0 &&
          selected.demo.includes("0") == false
        )
        return;

        //As is
        if (
          item.asis &&
          selected.asis.length > 0 &&
          selected.asis.includes("1") == false
        )
          return;

        if (
          !item.asis &&
          selected.asis.length > 0 &&
          selected.asis.includes("0") == false
        )
        return;

        //Certified
        if (
          item.certified &&
          selected.certified.length > 0 &&
          selected.certified.includes("1") == false
        )
          return;

        if (
          !item.certified &&
          selected.certified.length > 0 &&
          selected.certified.includes("0") == false
        )
        return;

        //Special
        if (
          item.special &&
          selected.special.length > 0 &&
          selected.special.includes("1") == false
        )
          return;

        if (
          !item.special &&
          selected.special.length > 0 &&
          selected.special.includes("0") == false
        )
        return;
        
        // engine displacement
        if (
            item.enginedisplacement &&
          enginedisplacementSet.size > 0 &&
          !enginedisplacementSet.has(item.enginedisplacement.toString())
        )
          return;
        if (!item.enginedisplacement && enginedisplacementSet.size > 0)
          return;
          
          // bodystyle
          if (
          item.bodystyle &&
          bodystyleSet.size > 0 &&
          !bodystyleSet.has(StringCache.normalize(item.bodystyle))
        )
          return;
          if (!item.bodystyle && bodystyleSet.size > 0)
          return;

          // fueltype
          if (
            item.fueltype &&
            fueltypeSet.size > 0 &&
            !fueltypeSet.has(StringCache.normalize(item.fueltype))
          )
            return;
            if (!item.fueltype && fueltypeSet.size > 0)
            return;
          
          //  stocknumber
        if (item.stocknumber && stockNumberSet) {
          if (!stockNumberSet.has(StringCache.toLower(item.stocknumber)))
          return;
        }

        // vin (substring match against any needle in vinList, case-insensitive,
        // ignores spaces and dashes). vinList is empty when no VIN filter is active.
        if (vinList.length > 0) {
          if (!item.vin) return;
          var itemVin = String(item.vin).toLowerCase().replace(/[\s-]/g, '');
          if (!vinList.some(needle => itemVin.indexOf(needle) !== -1)) return;
        }

        // price - treat items without price as price = 0
        const itemPrice = item.price || 0;
        if (!(itemPrice >= priceRange[0] && itemPrice <= priceRange[1]))
          return;

        // mileage - treat items without mileage as mileage = 0
        const itemMileage = item.mileage || 0;
        if (!(itemMileage >= mileageRange[0] && itemMileage <= mileageRange[1]))
          return;

        // carprooflink
        if (item.carprooflink) {
          // Intentar convertir item.carprooflink a un número
          const carprooflinkNumber = Number(item.carprooflink);
        
          // Verificar si la conversión fue exitosa y si está dentro del rango
          if (!isNaN(carprooflinkNumber) &&
              !(carprooflinkNumber >= carprooflinkRange[0] && carprooflinkNumber <= carprooflinkRange[1])) {
            return;
          }
        }
        
        if (
          (!item.carprooflink || item.carprooflink == "") &&
          (carprooflinkRange[0] > payload.minCarprooflink || carprooflinkRange[1] < payload.maxCarprooflink)
          )
            return;  

        // payment
          if (
          item.payments &&
          (item.payments.biweekly != 0 || item.payments.weekly != 0 || item.payments.monthly != 0) &&
          (paymentRange[0] != 0 && paymentRange[1] != 0) &&
          !(item.payments[paymentFrequency] >= paymentRange[0] && item.payments[paymentFrequency] <= paymentRange[1])
        ){
          return;
        }
        if (
          (!item.payments || (item.payments.biweekly == 0 && item.payments.weekly == 0 && item.payments.monthly == 0)) &&
          (paymentRange[0] != 0 && paymentRange[1] != 0) &&
          (paymentRange[0] > payload.minPayment || paymentRange[1] < payload.maxPayment)
          ){
            return; 
          }
        

        // dryweight
        if (
          item.dryweight &&
          !(item && item.dryweight != undefined && item.dryweight != null && parseInt(item.dryweight) >= parseInt(dryweightRange[0]) && parseInt(item.dryweight) <= parseInt(dryweightRange[1]))
        )
          return;
        if (
          !item.dryweight &&
          (dryweightRange[0] > payload.minDryweight || dryweightRange[1] < payload.maxDryweight)
        )
          return;

        // grossweight
        if (
          item.grossweight &&
          !(item && item.grossweight != undefined && item.grossweight != null && parseInt(item.grossweight) >= parseInt(grossweightRange[0]) && parseInt(item.grossweight) <= parseInt(grossweightRange[1]))
        )
          return;
        if (
          !item.grossweight &&
          (grossweightRange[0] > payload.minGrossweight || grossweightRange[1] < payload.maxGrossweight)
        )
          return;

        // sleepcapacity
        if (
          item.sleepcapacity &&
          !(item && item.sleepcapacity != undefined && item.sleepcapacity != null && parseInt(item.sleepcapacity) >= parseInt(sleepcapacityRange[0]) && parseInt(item.sleepcapacity) <= parseInt(sleepcapacityRange[1]))
        )
          return;
        if (
          !item.sleepcapacity &&
          (sleepcapacityRange[0] > payload.minSleepcapacity || sleepcapacityRange[1] < payload.maxSleepcapacity)
        )
          return;

        // superstring
        const currentYear = (new Date().getFullYear()+2);
        if (filterValue.length === 4 && !isNaN(filterValue) && (parseInt(filterValue) >= 1950 && parseInt(filterValue) <= currentYear)) {
          if (filterValue.indexOf(item.year) == -1) {
            return;
          }
        } else if (filterValue.length > 0 && !this.string_contains_value(super_string, filterValue.replace(/ /g, '_'))) {
          return;
        }

        // searchablesarray
        if (
          item.searchablesarray &&
          featureSet.size > 0
        ) {
          const normalizedSearchables = new Set(item.searchablesarray.map(sa => StringCache.normalize(sa)));
          var featintersection = selected.feature.filter(o => normalizedSearchables.has(StringCache.normalize(o)));
          if (featintersection.length < selected.feature.length)
            return;
        }
        if (!item.searchablesarray && featureSet.size > 0)
          return;

        // searchables
        if (
          item.searchables &&
          packageSet.size > 0
        ) {
          var searchablesExploded = new Set(item.searchables.split(',').map(i => StringCache.toLower(i)));
          var packintersection = selected.package.filter(p => searchablesExploded.has(StringCache.toLower(p)));

          if (!packintersection.length)
            return;
          
        }
        if (!item.searchables && packageSet.size > 0)
          return;

        // engine
        if (
          item.engine &&
          engineSet.size > 0 &&
          !engineSet.has(StringCache.normalize(item.engine))
          )
        {
          return;
        }
        if (!item.engine && engineSet.size > 0)
          return;
          
        // location
        if (
          item.location &&
          locationSet.size > 0 &&
          !locationSet.has(item.location.toUpperCase())
        )
          return;
        if (!item.location && locationSet.size > 0)
          return;
    
        // Seat
        if (
          item.seats &&
          seatSet.size > 0 &&
          !seatSet.has(item.seats.toString())
        )
          return;
        if (!item.seats && seatSet.size > 0)
          return;

        // Tags - vehicle must have ALL selected tags
        if (tagSet.size > 0) {
          if (!item.tags) return;
          const vehicleTags = new Set(
            String(item.tags).split(',').map(t => StringCache.toLower(t.trim()))
          );
          for (const requiredTag of tagSet) {
            if (!vehicleTags.has(requiredTag)) return;
          }
        }

        filteredInventory.push(item);

      });

      return filteredInventory;
    },
    getJSONTimestamp(minutes, name) {
      let lastTimestamp = sessionStorage.getItem("lastUpdate" + name + "JSON");
      let currentDate = new Date();
      if (lastTimestamp) {
        var lastUpdateDate = new Date(lastTimestamp * 1000);
        let minutesDifference = (currentDate - lastUpdateDate) / (60 * 1000);
        if (minutesDifference <= minutes) {
          return lastUpdateDate;
        } else {
          return currentDate;
        }
      } else {
        return currentDate;
      }
    },
    needsUpdateJSONTimestamp(minutes, name) {
      let lastTimestamp = sessionStorage.getItem("lastUpdate" + name + "JSON");
      let currentDate = new Date();

      if (lastTimestamp) {
        var lastUpdateDate = new Date(lastTimestamp * 1000);
        let minutesDifference = (currentDate - lastUpdateDate) / (60 * 1000);

        console.warn("LBX: Minutes Difference --> ", minutesDifference);
        if (minutesDifference <= minutes) {
          console.warn("LBX: No need to update");
          return false;
        } else {
          console.warn("LBX: Needs to update");
          sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
          return true;
        }
      } else {
        console.warn("LBX: lastUpdate session storage not found");
        sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
        return false;
      }
    },
    priceInRange(item, price) {
      var min = parseFloat(item.minprice) || 0;
      var max = parseFloat(item.maxprice) || 0;
      var vehiclePrice = parseFloat(price) || 0;

      if (min > 0 && vehiclePrice < min) return false;
      if (max > 0 && vehiclePrice > max) return false;

      return true;
    },
    maxTermItem(vehicleFinance, vehicleYear, vehicleModel, vehiclePrice) {
      if (!(vehicleFinance instanceof Array)) return vehicleFinance;
      
      var currentYear = new Date().getFullYear();
      let max = 0;
      let i = 0;
      let z = 0;
      let selected = -1;
    
      if (vehicleFinance != null) {
        if(!vehicleFinance.modelFinancing){
            Object.values(vehicleFinance).forEach(item => {
              if(item.term > max){
                max = item.term;
                selected = i;
              }
              i++;
            })
        }else{
          Object.values(vehicleFinance).forEach((item) => {
            if (item.models) {
              if (
                item.models.toLowerCase().includes(vehicleModel.toLowerCase()) &&
                vehicleYear >= item.startyear &&
                vehicleYear <= item.endyear &&
                !item.isCPO &&
                this.priceInRange(item, vehiclePrice)
              ) {
                max = item.term;
                selected = i;
              }
            }
            i++;
          });
      
          if (selected == -1) {
            Object.values(vehicleFinance).forEach((item) => {
              if (
                item &&
                vehicleModel &&
                item.models &&
                !item.isCPO &&
                item.models.toLowerCase().indexOf("all") !== -1 &&
                this.priceInRange(item, vehiclePrice)
              ) {
                if (parseInt(item.startyear) <= 0 && parseInt(item.endyear) > 0) {
                  if (
                    vehicleYear >= currentYear - Math.abs(item.startyear) &&
                    vehicleYear <= item.endyear
                  ) {
                    max = item.term;
                    selected = z;
                  }
                } else if (
                  parseInt(item.endyear) <= 0 &&
                  parseInt(item.startyear) > 0
                ) {
                  if (
                    vehicleYear >= item.startyear &&
                    vehicleYear <= currentYear - Math.abs(item.endyear)
                  ) {
                    max = item.term;
                    selected = z;
                  }
                } else if (
                  parseInt(item.endyear) <= 0 &&
                  parseInt(item.startyear) <= 0
                ) {
                  if (
                    vehicleYear >= currentYear - Math.abs(item.startyear) &&
                    vehicleYear <= currentYear - Math.abs(item.endyear)
                  ) {
                    max = item.term;
                    selected = z;
                  }
                } else {
                  if (vehicleYear >= item.startyear && vehicleYear <= item.endyear) {
                    max = item.term;
                    selected = z;
                  }
                }
              }
              z++;
            });
          }
        }
      }
      if (selected == -1) return {};
    
      return JSON.parse(JSON.stringify(vehicleFinance[selected]));
    },    
    financeRateCPO(financeCPO,year,model,price){
      var selected = {};
      var currentYear = new Date().getFullYear();
      var rules = Object.values(financeCPO || {}).filter(item => item && this.priceInRange(item, price));

      if(!this.financeUsedData.modelFinancing){
          rules.forEach(item => {
            if(item && model && item.models && item.models.toLowerCase().indexOf(model.toLowerCase()) !== -1){
              if(year >= item.startyear && year <= item.endyear){
                selected = item;
              }
            }
          })
          
          if(Object.keys(selected).length === 0) {
            rules.forEach(item => {
              if(item && model && item.models && item.models.toLowerCase().indexOf("other") !== -1){
                if(year >= item.startyear && year <= item.endyear){
                  selected = item;
                }
              }
            })
          }
      }else{
          rules.forEach(item => {
              if(item && model && item.models && item.isCPO && item.models.toLowerCase().indexOf(model.toLowerCase()) !== -1){
                if(year >= item.startyear && year <= item.endyear){
                  selected = item;
                }
              }
           });

           if(Object.keys(selected).length === 0) {
              rules.forEach(item => {
                if(item && model && item.models && item.isCPO && item.models.toLowerCase().indexOf("all") !== -1){
                  if(parseInt(item.startyear) <= 0 || parseInt(item.endyear) <= 0){
                      if( year >= (currentYear - Math.abs(item.startyear))  && year <= (currentYear - Math.abs(item.endyear)) )
                          selected = item;
                  }else{
                      if(year >= item.startyear && year <= item.endyear)
                          selected = item;
                  }
                }
              })
            }
      }

      return selected;
    },
    calculateFinance(financeArray, frequency, vehiclePrice){
      if (financeArray.term === 0) return 0;
      
      let remainingPrice = vehiclePrice;
      
      if (financeArray.value === 0) return remainingPrice / financeArray.term;
  
      let monthlyPayment = Math.round((((remainingPrice) * (financeArray.value / 1200)) * Math.pow((1 + (financeArray.value / 1200)), financeArray.term)) / (Math.pow((1 + (financeArray.value / 1200)), financeArray.term) - 1) * 100) / 100;
      
      switch (frequency) {
          case 'weekly':
              return Math.round(((monthlyPayment * 12) / 52).toFixed(2));
          case 'bi-weekly':
              return Math.round(((monthlyPayment * 12) / 26).toFixed(2));
          case 'monthly':
          default:
              return Math.round(monthlyPayment.toFixed(2));
      }
    },
    calculatePayment(vehicle, frequency) {

      if(vehicle.condition == 'New'){
        return this.calculateFinance(vehicle.finance, frequency, vehicle.price);
      }else if(vehicle.condition == 'Used' && this.usedFinancing){

        let vehicleFinance = {};
        let finalFinance = {};

          if(this.vehicleCertified && this.usedFinancing && this.usedFinancing.cpo){
            if(!this.usedFinancing.modelFinancing){
              vehicleFinance = this.financeRateCPO(this.usedFinancing.cpo, vehicle.year, vehicle.model, vehicle.price);
            }else{
              vehicleFinance = this.financeRateCPO(this.usedFinancing.financeByModel, vehicle.year, vehicle.model, vehicle.price);
            }
          }
          else{
            if(this.usedFinancing.specialFinancing && !this.usedFinancing.modelFinancing){
              var currentYear = new Date().getFullYear();
              var yearDiff = currentYear - vehicle.year;

              if(this.usedFinancing.yearsForSubfinance && yearDiff <= this.usedFinancing.yearsForSubfinance)
                  vehicleFinance = this.usedFinancing.subfinance || {term: 0, value: 0};
              else if(this.usedFinancing.yearsForSubfinance && yearDiff > this.usedFinancing.yearsForSubfinance)
                  vehicleFinance = this.usedFinancing.finance || {term: 0, value: 0};
              else
                  vehicleFinance = this.usedFinancing.defaultFinance || {term: 0, value: 0};
            }else if(this.usedFinancing.modelFinancing)
                vehicleFinance = this.usedFinancing.financeByModel || {term: 0, value: 0};
            else
                vehicleFinance = this.usedFinancing || {term: 0, value: 0};
          }

          finalFinance = this.maxTermItem(vehicleFinance, vehicle.year, vehicle.model, vehicle.price);
          return this.calculateFinance(finalFinance, frequency, vehicle.price);
        } else{
          return 0;
        }
    },
    setPayments() {
      return new Promise((resolve, reject) => {
        let setPayments = localStorage.getItem("lbx_setPayments");

        if (!setPayments) {
          localStorage.setItem("lbx_setPayments", true);
      
          // Nombre de la base de datos y el almacén de objetos
          const dbName = 'lbx-inventory';
          const storeName = 'inventory';
      
          // Abrir una conexión a la base de datos
          const request = indexedDB.open(dbName, 2);
      
          request.onerror = (event) => {
            reject('Error to open the database');
          };
      
          request.onsuccess = (event) => {
            const db = event.target.result;
      
            // Abrir una transacción en modo de lectura/escritura
            const transaction = db.transaction(storeName, 'readwrite');
            const objectStore = transaction.objectStore(storeName);
      
            // Realizar una solicitud para obtener todos los registros
            const getAllRequest = objectStore.getAll();
      
            getAllRequest.onerror = (event) => {
              console.error('Error to get the data:', event.target.errorCode);
              reject('Error to get the data');
            };
      
            getAllRequest.onsuccess = (event) => {
              const data = event.target.result;
      
              // Recorrer y modificar los datos directamente en IndexedDB
              data.forEach(item => {
                item.payments = {
                  weekly: this.calculatePayment(item, 'weekly'),
                  biweekly: this.calculatePayment(item, 'bi-weekly'),
                  monthly: this.calculatePayment(item, 'monthly')
                };
      
                // Actualizar cada item en el almacén de objetos
                const updateRequest = objectStore.put(item);
      
                updateRequest.onerror = (event) => {
                  console.error('Error to update the data:', event.target.errorCode);
                  reject('Error to update the data');
                };
      
                updateRequest.onsuccess = (event) => {
                  // re-escribe el json por el nuevo
                  //this.saveInventoryJson(data);
                };
              });
      
              // Esperar hasta que la transacción se complete
              transaction.oncomplete = () => {
                resolve(data);
              };
            };
          };
        }else {
          resolve(false);
        }
      });
    },        
  },
  mounted() {},
  watch: {}
});
export default EventBus;